import React, { useContext } from 'react'

export const CompactSectionsContext = React.createContext<boolean>(false)

export const useIsCompactSections = () => useContext(CompactSectionsContext)
